import { mapGetters } from "vuex";

export const generalMixin = {
  computed: {
    ...mapGetters({
      affichage: "general/show/affichage",
      paramsRob: "general/show/paramsRob",
      breadCrumbs: "general/show/breadCrumbs",
    }),
  },
};
